import React from 'react'
import styled from 'styled-components'
import { Bet } from 'state/types'
// import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'react-i18next'
import { Flex, Text } from 'uikit'
import { Result } from 'state/predictions/helpers'
import { PayoutRow, RoundResultHistory } from '../RoundResult'
import BetResult from './BetResult'
import { getMultiplier } from './helpers'

interface BetDetailsProps {
  bet: Bet
  result: Result
}

const StyledBetDetails = styled.div`
  background-color: white;
  padding: 20px;
  border: 1px solid rgba(115, 126, 141, 0.16);
  border-radius: 0 0 16px 16px;
  margin: -15px 24px 15px;
`

const BetDetails: React.FC<BetDetailsProps> = ({ bet, result }) => {
  const { t } = useTranslation()
  const { totalAmount, bullAmount, bearAmount } = bet.round
  const bullMultiplier = getMultiplier(totalAmount, bullAmount)
  const bearMultiplier = getMultiplier(totalAmount, bearAmount)

  return (
    <StyledBetDetails>
      {result === Result.CANCELED && (
        <Text as="p" color="#F9479C" mb="24px" fontSize="14px">
          {t('PREDICTION_96')}
        </Text>
      )}
      {result !== Result.LIVE && <BetResult bet={bet} result={result} />}
      <Text fontSize="14px" bold mb="10px">
        {t('PREDICTION_97')}
      </Text>
      <RoundResultHistory round={bet.round} mb="24px">
        <PayoutRow positionLabel={t('Up')} multiplier={bullMultiplier} amount={bullAmount} mb="8px" />
        <PayoutRow positionLabel={t('Down')} multiplier={bearMultiplier} amount={bearAmount} />
      </RoundResultHistory>
      {bet.round.lockBlock && (
        <Flex alignItems="center" justifyContent="space-between" mb="8px">
          <Text>
            {t('PREDICTION_98')} {bet.round.lockBlock}
          </Text>
          {/* <Link href={getKCCExplorerLink(chainId, bet.round.lockBlock, 'block')} external>
            
          </Link> */}
          {bet.round.lockBlock}
        </Flex>
      )}
      {bet.round.closeBlock && (
        <Flex alignItems="center" justifyContent="space-between">
          <Text>
            {t('PREDICTION_99')} {bet.round.closeBlock}
          </Text>
          {/* <Link href={getKCCExplorerLink(chainId, bet.round.closeBlock, 'block')} external>
          </Link> */}
          {bet.round.closeBlock}
        </Flex>
      )}
    </StyledBetDetails>
  )
}

export default BetDetails
